<ion-content>
  <div class="tags-sorting-container">
    <div class="sorting-container">
      <div class="sorting-title">{{ "TAGS_MODAL_PAGE.SORTING" | translate }}</div>
      <div class="sorting-options">
        <div class="sorting-option" tappable (click)="selectedSorterType = sorterType.value" *ngFor="let sorterType of sorterTypes">
          <ion-icon
            [class.checked-icon]="selectedSorterType === sorterType.value"
            [src]="
              selectedSorterType === sorterType.value
                ? '/assets/custom-icons/b-check-circle-solid.svg'
                : '/assets/custom-icons/b-circle.svg'
            "
          ></ion-icon>
          <p>{{ sorterType.text | translate }}</p>
        </div>
      </div>
    </div>
    <div class="tags-container">
      <div class="tags-title">{{ "TAGS_MODAL_PAGE.TAGS" | translate }}</div>
      <div class="tags-options">
        <div class="tags-option" tappable (click)="tag.selected = !tag.selected" *ngFor="let tag of tags">
          <ion-icon *ngIf="!tag.selected" src="/assets/custom-icons/b-square.svg"></ion-icon>
          <ion-icon class="checked-icon" *ngIf="tag.selected" src="/assets/custom-icons/b-check-square.svg"></ion-icon>
          <p>{{ tag.name }}</p>
          <span>{{ tag.resultsCount }}</span>
        </div>
      </div>
    </div>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-row>
      <ion-col class="ion-no-padding">
        <ion-button (click)="onRemoveAll()" expand="block" class="custom-button" color="grey">
          {{ "TAGS_MODAL_PAGE.REMOVE_ALL" | translate }}
        </ion-button>
      </ion-col>
      <ion-col class="ion-no-padding">
        <ion-button (click)="onApply()" expand="block" class="custom-button" color="green">
          {{ "TAGS_MODAL_PAGE.APPLY" | translate }}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-footer>
